import styled from 'styled-components'
import Icon from './Icon'

const PrintIcon = styled(Icon).attrs({
  type: 'print',
})``

export default PrintIcon
